<template>
  <div class="interview-verify">
    <h1 class="interview-verify-title">{{ $t('interview.verify.tip') }}</h1>
    <Divider dashed />
    <!-- 验证身份 -->
    <Form :model="formValidate" :rules="ruleValidate" ref="formValidate">
      <FormItem prop="name" :label="$t('interview.verify.displayName')">
        <Input
          :placeholder="$t('interview.verify.displayNameInput')"
          class="input"
          v-model="formValidate.name"
        ></Input>
      </FormItem>
      <FormItem prop="mobile" :label="$t('interview.verify.mobile')">
        <Input
          :placeholder="$t('global.text29')"
          class="input"
          v-model="formValidate.mobile"
        >
          <Select
            v-model="formValidate.mobilePrefix"
            slot="prepend"
            style="width: 100px"
          >
            <Option
              v-for="(a, i) in areaCodeList"
              :key="i"
              :value="`${a.value}`"
              :label="`+${a.value}`"
            >
              {{ a.key }}+{{ a.value }}
            </Option>
          </Select>
        </Input>
      </FormItem>
      <FormItem
        :error="codeError ? $t('global.codeError') : null"
        :label="$t('interview.verify.code')"
      >
        <Input
          class="input"
          v-model="code"
          :placeholder="$t('global.codePlaceholder')"
          @on-change="onCodeChange"
        >
          <Button
            id="TencentCaptcha"
            slot="append"
            :style="{
              cursor:
                formValidate.mobilePrefix && formValidate.mobile
                  ? 'pointer'
                  : 'not-allowed'
            }"
            @click="getCode"
          >
            <template v-if="countdown === second">
              {{ $t('global.getCode') }}
            </template>
            <template v-if="countdown > 0 && countdown < second">
              {{ countdown }}{{ $t('global.codeResend') }}
            </template>
            <template v-if="countdown === 0">
              {{ $t('global.reCodeResend') }}
            </template>
          </Button>
        </Input>
      </FormItem>
    </Form>
    <Button
      long
      type="primary"
      :disabled="!code"
      :loading="sbLoading"
      @click="on_submits"
    >
      {{ $t('global.text19') }}
    </Button>
  </div>
</template>
<style lang="less">
.interview-verify {
  padding: 24px;
  background: #fff;
  .interview-verify-title {
    color: #1c2438;
    font-weight: 700;
    font-size: 16px;
    line-height: 1;
    text-align: left;
    margin-bottom: 8px;
  }
}
</style>
<script>
import axios from 'axios';
import app_config from '@/commons/app_config';
import { mapMutations } from 'vuex';
export default {
  data() {
    const validatemobile = async (rule, value, callback) => {
      if (value) {
        if (this.formValidate.mobilePrefix === '852') {
          if (value.length !== 8) {
            return callback(
              new Error(this.$t('global.enter_true_mobile_phone'))
            );
          }
        } else {
          if (
            !this.$parsePhoneNumberFromString(
              value,
              `+${this.formValidate.mobilePrefix}`
            )
          ) {
            return callback(
              new Error(this.$t('global.enter_true_mobile_phone'))
            );
          }
        }
        const mPattern = /[^\d]/g;
        if (mPattern.test(value)) {
          return callback(new Error(this.$t('global.enter_true_mobile_phone')));
        }
      } else {
        return callback(new Error(this.$t('global.enter_true_mobile_phone')));
      }
    };
    this.captcha = null;
    this.captchaRes = {
      ticket: null,
      randstr: null
    };
    this.second = 60;
    return {
      step: 'verify',
      code: null,
      codeError: false,
      sbLoading: false,
      formValidate: {
        teamId: this.$route.query.teamId,
        mobilePrefix: 86,
        mobile: '',
        name: ''
      },
      areaCodeList: [],
      ruleValidate: {
        name: [
          {
            required: true,
            message: this.$t('interview.verify.displayNameInput')
          }
        ],
        mobile: [
          {
            required: true,
            validator: validatemobile
          }
        ]
      },
      countdown: this.second
    };
  },
  created() {
    document.title = this.$t('interview.verify.name');
  },
  mounted() {
    this.initVerificationCode();
    this.getMobilePrefixList();
    const interviewName = this.$route.query.interviewName;
    if (interviewName) {
      this.formValidate.name = interviewName;
    }
  },
  methods: {
    ...mapMutations({
      set_interviews: 'set_interviews'
    }),
    // 获取手机区号列表
    async getMobilePrefixList() {
      const res = await this.$http(
        'get',
        'public/dictionaries/area_code',
        { code: 'area_code' },
        true
      );
      this.areaCodeList = res.data.dictValues;
    },
    initVerificationCode() {
      const langLocal = {
        hk: 'zh-hk',
        cn: 'zh-cn',
        en: 'en',
        id: 'id'
      };
      const codeLang = langLocal[this.$i18n.locale];
      this.captcha = new TencentCaptcha(
        '2034105263',
        (res) => {
          // res（用户主动关闭验证码）= {ret: 2, ticket: null}
          // res（验证成功） = {ret: 0, ticket: "String", randstr: "String"}
          if (res.ret === 0) {
            this.captchaRes = res;
            this.sendTextMessage();
          }
        },
        {
          userLanguage: codeLang
        }
      );
    },
    onCodeChange: _.debounce(function (e) {
      if (e.target.value) {
        this.codeError = false;
      }
    }, 500),
    getLanguage() {
      const browserLocaleMap = {
        cn: 'zh-CN',
        en: 'en',
        hk: 'zh-HK'
      };
      const defaultI18n =
        process.env.VUE_APP_REGION === 'yoov' ? 'zh-HK' : 'zh-CN';
      const i18n = localStorage.getItem('i18n');
      const browserLocale = browserLocaleMap[i18n]
        ? browserLocaleMap[i18n]
        : 'zh-HK';
      return _.isNil(i18n) ? defaultI18n : browserLocale;
    },
    // 发送短信验证码
    async sendTextMessage() {
      const url = `${process.env.VUE_APP_MAIN_PASS_URL}/auth/realms/yoov/api/v1/auth/otp/apply`;
      await axios({
        method: 'post',
        url: url,
        headers: {
          'Accept-Language': this.getLanguage()
        },
        data: {
          clientId: 'yoov-oa',
          mobilePrefix: this.formValidate.mobilePrefix,
          mobile: this.formValidate.mobile,
          code: '',
          captchaToken: this.captchaRes.randstr,
          captchaAuthenticate: this.captchaRes.ticket,
          channel: 'sms',
          type: 'login',
          scope: 'offline_access'
        }
      }).catch((error) => {
        if (error.response) {
          this.$Message.error(error.response.data.error_description);
        } else if (error.request) {
          // 请求已经成功发起，但没有收到响应
          // `error.request` 在浏览器中是 XMLHttpRequest 的实例，
          // 而在node.js中是 http.ClientRequest 的实例
        } else {
          // 发送请求时出了点问题
          this.$Message.error(error.error_description);
        }
      });
      if (this.countdown === 0) {
        this.countdown = this.second;
      }
      this.countdownFu();
    },
    countdownFu() {
      this.countdown--;
      const t = setInterval(() => {
        this.countdown--;
        if (this.countdown === 0) {
          clearInterval(t);
        }
      }, 1000);
    },
    getCode() {
      if (this.formValidate.mobilePrefix && this.formValidate.mobile) {
        this.$refs.formValidate.validate(async (v) => {
          if (v) {
            this.captcha.show();
          }
        });
      }
    },
    on_submits() {
      this.$refs.formValidate.validate(async (v) => {
        if (v) {
          let codeVerify = null;
          const url = `${process.env.VUE_APP_MAIN_PASS_URL}/auth/realms/yoov/api/v1/auth/otp/verify`;
          codeVerify = await axios({
            method: 'post',
            url: url,
            data: {
              clientId: 'yoov-oa',
              mobilePrefix: this.formValidate.mobilePrefix,
              mobile: this.formValidate.mobile,
              code: this.code,
              captchaToken: this.captchaRes.randstr,
              captchaAuthenticate: this.captchaRes.ticket,
              channel: 'sms',
              type: 'login',
              scope: 'offline_access',
              verified: true
            }
          });
          if (!codeVerify || (codeVerify && codeVerify.data)) {
            this.onInterView();
          } else {
            this.codeError = true;
            this.$Message.error(this.$t('global.codeError'));
          }
        }
      });
    },
    async onInterView() {
      try {
        this.sbLoading = true;
        let url = `${app_config.mainApiEndpoint}/rest/api/v1/self/recruitment/interview/interviews`;
        const { data } = await this.$http('POST', url, this.formValidate, true);
        this.set_interviews(data);
        this.$router.push(
          `/interview/signedQR/checkIn?teamId=${this.formValidate.teamId}&interviewName=${this.formValidate.name}`
        );
      } finally {
        this.sbLoading = false;
      }
    }
  }
};
</script>
